<script lang="ts" setup>
import { computed, type PropType } from 'vue'

interface HourCounterItem {
  timestamp: string | Date
  hpuMinCounter: number
}

const props = defineProps({
  hoursData: {
    type: Array as PropType<HourCounterItem[]>,
    required: true,
    default: () => []
  }
});

const formatDate = (d: string | Date) => {
  if (!d) return '-'
  return new Date(d).toLocaleString(undefined, {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

const getFormattedTime = (HPUMinCounter: number) => {
    const hours = Math.floor(HPUMinCounter / 60);
    const minutes = HPUMinCounter % 60;
    return `${hours}t ${minutes}m`;
}

const formatRuntime = (minutes: number) => {
    return getFormattedTime(minutes);
}

const hasData = computed(() => props.hoursData && props.hoursData.length > 0);

const lastRegisteredValue = computed(() => {
    return hasData.value ? props.hoursData[props.hoursData.length - 1] : null;
});
</script>

<template>
  <v-container fluid>
    <v-alert
      v-if="!hasData"
      type="info"
      variant="tonal"
      class="mb-4"
    >
      No Hour Counter data recorded.
    </v-alert>

    <div v-else class="d-flex justify-center">
      <v-card v-if="lastRegisteredValue" class="text-center pa-6" min-width="300" elevation="2">
        <div class="text-uppercase text-medium-emphasis text-subtitle-2 font-weight-bold mb-2">Current HPU Runtime</div>
        <div class="text-h3 font-weight-bold text-blue-grey-darken-4 d-flex align-center justify-center mb-2">
            <v-icon size="large" color="grey-darken-1" class="mr-3">mdi-cog</v-icon>
            {{ formatRuntime(lastRegisteredValue.hpuMinCounter) }}
        </div>
        <div class="text-caption text-medium-emphasis">Last registered: {{ formatDate(lastRegisteredValue.timestamp) }}</div>
      </v-card>
    </div>
  </v-container>
</template>